import React, { lazy } from 'react'
import HomeHero from '../Home/HomeHero'
import HomeCategories from '../Home/HomeCategories'
import HomeRunProfitably from '../Home/HomeRunProfitably'
import HomeValueSolutions from '../Home/HomeValueSolutions'
import HomeWeServe from '../Home/HomeWeServe'
import HomeAccount from '../Home/HomeAccount'
import HomeAbout from '../Home/HomeAbout'
import HomeBusiness from '../Home/HomeBusiness'
import HomeSmallBanner from '../Home/HomeSmallBanner'
import HomeAlertBanner from '../Home/HomeAlertBanner'
import ContentBannerSection from './ContentBannerSection'
import ContentHeaderSection from './ContentHeaderSection'
import ContentInfoSection from './ContentInfoSection'
import ContentHeaderHero from './ContentHeaderHero'
import ContentHeaderHeroNew from '../About/AboutHeaderHero'
import ServicesSection from './ServicesSection'
import WarehouseSection from './WarehouseSection'
import WarehouseSectionB from './WarehouseSectionB'
import WarehouseSectionC from './WarehouseSectionC'
import MarketsServedServices from '../MarketsServed/MarketsServedServices'
import FeaturedCategoriesCarouselLayout from '../FeaturedCategories/FeaturedCategoriesCarouselLayout'
import SideBySide from './SideBySide'
// import IndustryInsights from '../Resources/IndustryInsights';
import ContactUs from '../ContactUs/ContactUs'
import ContentTextSection from './ContentTextSection'
import EmeraldAboutSection from './EmeraldAboutSection'
import EmeraldCategoriesMobile from './EmeraldCategoriesMobile'
import EmeraldCategoriesSection from './EmeraldCategoriesSection'
import EmeraldContactFormSection from './EmeraldContactFormSection'
import EmeraldContactSection from './EmeraldContactSection'
import EmeraldEverythingYouNeedSection from './EmeraldEverythingYouNeedSection'
import EmeraldHomeBannerSection from './EmeraldHomeBannerSection'
import EmeraldRunProfitablySection from './EmeraldRunProfitablySection'
import EmeraldRuntimeSection from './EmeraldRuntimeSection'
import EmeraldValueAddedSection from './EmeraldValueAddedSection'
import EmeraldWhoWeServeSection from './EmeraldWhoWeServeSection'
import loadable from '@loadable/component'
// import PDFDisplay from '../Terms/PDFDisplay';

const PageSectionSwitch = ({ section, index }) => {
  const PDFDisplay = loadable(() => import('../Terms/PDFDisplay'))
  const propsData = section.fields
  const sectionStyle = { backgroundColor: index % 2 !== 0 ? '#f1f3f7' : undefined }
  switch (section.sys.contentType.sys.id) {
    case 'medSupplyContentBanner':
      return <ContentBannerSection key={section.sys.id} props={propsData} />
    case 'medSupplyContentHeading':
      return <ContentHeaderSection key={section.sys.id} props={propsData} />
    case 'medSupplyContentSection':
      return <ContentInfoSection key={section.sys.id} style={sectionStyle} props={propsData} />
    case 'homehero':
      return <HomeHero key={section.sys.id} heroData={propsData} />
    case 'homecategories':
      return <HomeCategories key={section.sys.id} categoriesData={propsData} />
    case 'homerunProfitably':
      return <HomeRunProfitably key={section.sys.id} runProfitablyData={propsData} />
    case 'homevalueSolutions':
      return <HomeValueSolutions key={section.sys.id} valueSolutionsData={propsData} />
    case 'homeWeServe':
      return <HomeWeServe key={section.sys.id} weServeData={propsData} />
    case 'homeaccount':
      return <HomeAccount key={section.sys.id} accountData={propsData} />
    case 'homeAbout':
      return <HomeAbout key={section.sys.id} aboutData={propsData} />
    case 'homeBusiness':
      return <HomeBusiness key={section.sys.id} businessData={propsData} />
    case 'whoWeServeHeaderHero':
      return propsData.layouttype === 'section2' ? (
        <ContentHeaderHeroNew key={section.sys.id} data={propsData} />
      ) : (
        <ContentHeaderHero key={section.sys.id} data={propsData} />
      )
    case 'aboutServicesSection':
      return <ServicesSection key={section.sys.id} data={propsData} />
    case 'aboutWarehouseSection':
      return propsData.identifier === 'layoutC' ? (
        <WarehouseSectionC key={section.sys.id} data={propsData} />
      ) : propsData.identifier === 'layoutB' ? (
        <WarehouseSectionB key={section.sys.id} data={propsData} />
      ) : (
        <WarehouseSection key={section.sys.id} data={propsData} />
      )
    case 'whoWeServeMarketsServedServices':
      return <MarketsServedServices key={section.sys.id} data={propsData} />
    case 'featuredCategoriesCarousel':
      return <FeaturedCategoriesCarouselLayout key={section.sys.id} data={propsData} />
    case 'resourcesSideBySide':
      return <SideBySide key={section.sys.id} data={propsData} />
    // case "industryInsightsSection":
    //   return <IndustryInsights key={section.sys.id} data={propsData} />;
    case 'homeSmallBanner':
      return <HomeSmallBanner key={section.sys.id} props={propsData} />
    case 'homeAlertBanner':
      return <HomeAlertBanner key={section.sys.id} props={propsData} />
    case 'contactPage':
      return <ContactUs key={section.sys.id} data={propsData} />
    case 'pdfDisplay':
      return <PDFDisplay key={section.sys.id} data={propsData} />
    case 'contentTextSection':
      return <ContentTextSection key={section.sys.id} data={propsData} />
    case 'aboutSection':
      return <EmeraldAboutSection key={section.sys.id} data={propsData} />
    case 'categoriesMobileSection':
      return <EmeraldCategoriesMobile key={section.sys.id} data={propsData} />
    case 'categoriesSection':
      return <EmeraldCategoriesSection key={section.sys.id} data={propsData} />
    case 'contactFormSection':
      return <EmeraldContactFormSection key={section.sys.id} data={propsData} />
    case 'contactSection':
      return <EmeraldContactSection key={section.sys.id} data={propsData} />
    case 'everythingYouNeedSection':
      return <EmeraldEverythingYouNeedSection key={section.sys.id} data={propsData} />
    case 'homeBannerSection':
      return <EmeraldHomeBannerSection key={section.sys.id} data={propsData} />
    case 'runProfitablySection':
      return <EmeraldRunProfitablySection key={section.sys.id} data={propsData} />
    case 'runtimeSection':
      return <EmeraldRuntimeSection key={section.sys.id} data={propsData} />
    case 'valueAddedSection':
      return <EmeraldValueAddedSection key={section.sys.id} data={propsData} />
    case 'whoWeServeSection':
      return <EmeraldWhoWeServeSection key={section.sys.id} data={propsData} />
    default:
      return <div>Unknown Section</div>
  }
}

export default PageSectionSwitch
